import { All, HTTPMethod } from '../../types/enums';
import BaseAdapter from './baseAdapter';
import { AdapterInterface } from '../../types/global';
import { adaptBackendFilters } from '../../utils/filters';
import { DebtInsightsRequest, DebtInsightsResponse } from '../../api-models';
import {
  DebtMetricCardProps, DebtMetricColumnProps, DebtMetricItemInterface, DebtMetricItemRequest,
} from '../../types/debt.type';

export default class PostDebtInsights extends BaseAdapter<DebtInsightsResponse>implements AdapterInterface {
  rawResponse: DebtInsightsResponse;

  modifiedRequest: DebtInsightsRequest;

  async adaptResponse(request: DebtMetricItemRequest): Promise<DebtMetricItemInterface> {
    const formattedRequest = this.adaptRequest(request);
    await this.fetchApiResponse('/api/debt/debt-insights', HTTPMethod.Post, formattedRequest);
    return {
      id: this.rawResponse.id,
      title: this.rawResponse.page_title,
      description: this.rawResponse.description,
      grid: this.rawResponse.grid_component.map((headline): DebtMetricCardProps => ({
        value: headline.value,
        label: headline.display_name,
        variance: headline.variance,
        trendUp: headline.trend,
        filters: adaptBackendFilters(headline.filters),
      })),
      columns: this.rawResponse.column_component.map((column): DebtMetricColumnProps => ({
        id: column.id,
        displayName: column.display_name,
        icon: column.icon,
        metrics: column.metrics.map((metric): DebtMetricCardProps => ({
          value: metric.value,
          variance: '',
          label: metric.display_name,
          filters: adaptBackendFilters(metric.filters),
        })),
      })),

    };
  }

  adaptRequest(request: DebtMetricItemRequest): DebtInsightsRequest {
    const liftDataId = request.liftDataId === All.value ? null : Number(request.liftDataId);
    this.modifiedRequest = {
      snapshot: request.snapshot,
      debt_type: request.debtType,
      lift_data_id: liftDataId,
      ward_name: request.wardName,
    };
    return this.modifiedRequest;
  }
}
